import { Compiler, Injectable, Injector, ViewContainerRef, Type, ComponentFactory } from '@angular/core';

import * as AngularCommon from '@angular/common';
import * as AngularCore from '@angular/core';

declare var window: any;
declare var SystemJS: any;

@Injectable({
  providedIn: 'root'
})
export class DynamicAppLoaderService {
  // @ViewChild('vc', {read: ViewContainerRef}) vc;

  constructor(
    private compiler: Compiler,
    private injector: Injector) {
  }

  get system() {
    // return SystemJS;
    return SystemJS || window.System;
  }

  async loadComponentFactoryFromModule(module: any): Promise<ComponentFactory<any>> {
    // register the modules that we already loaded so that no HTTP request is made
    // in my case, the modules are already available in my bundle (bundled by webpack)
    this.system.set('@angular/core', this.system.newModule(AngularCore));
    this.system.set('@angular/common', this.system.newModule(AngularCommon));

    const compiled = await this.compiler.compileModuleAndAllComponentsAsync(module);

    const moduleRef = compiled.ngModuleFactory.create(this.injector);
    const factory = compiled.componentFactories[0];

    return factory;
  }

  /**
   * @param moduleEntryPoint Path to the module js file
   */
  async loadComponentFactoryFromFile(moduleEntryPoint: string): Promise<ComponentFactory<any>> {
    const module = await this.system.import(moduleEntryPoint);

    return this.loadComponentFactoryFromModule(module);
  }

  /**
   * <ng-container #vc></ng-container>
   * @param vc @ViewChild('vc', {read: ViewContainerRef}) vc
   * @param moduleEntryPoint Path to the module js file
   */
  /*async loadFromFile(vc: ViewContainerRef, moduleEntryPoint: string): Promise<any> {
    // register the modules that we already loaded so that no HTTP request is made
    // in my case, the modules are already available in my bundle (bundled by webpack)
    SystemJS.set('@angular/core', SystemJS.newModule(AngularCore));
    SystemJS.set('@angular/common', SystemJS.newModule(AngularCommon));

    // now, import the new module
    const module = await SystemJS.import(moduleEntryPoint);

    return await this.loadFromModule(vc, module.default);

    const compiled = await this.compiler.compileModuleAndAllComponentsAsync(module.default);

    const moduleRef = compiled.ngModuleFactory.create(this.injector);
    const factory = compiled.componentFactories[0];

    if (factory) {
      const component = vc.createComponent(factory);
      const instance = component.instance;

      return instance;
    }

    throw new Error("Component not found");
  }*/

  /*async loadFromModule(vc: ViewContainerRef, module: Type<any>) {
    const compiled = await this.compiler.compileModuleAndAllComponentsAsync(module);

    const moduleRef = compiled.ngModuleFactory.create(this.injector);
    const factory = compiled.componentFactories[0];

    if (factory) {
      const component = vc.createComponent(factory);
      const instance = component.instance;

      return instance;
    }

    throw new Error("Component not found");
  }*/
}
